const BodyScroll = {
  scrollY: 0,

  styles: {
    position: 'fixed',
    overflow: 'hidden',
    left: 0,
    width: '100%',
  },

  fixed: function (isFixed) {
    if (isFixed) {
      this.scrollY = window.pageYOffset || document.documentElement.scrollTop;
      this.styles.top = (this.scrollY * -1) + 'px';
      const scrollbarWidth = (window.innerWidth - document.documentElement.clientWidth) + 'px'
      this.styles.marginRight = scrollbarWidth
      Object.keys(this.styles).forEach(function (key) {
        document.body.style[key] = this.styles[key];
      }.bind(this));
    } else {
      Object.keys(this.styles).forEach(function (key) {
        document.body.style[key] = '';
      });
      window.scrollTo(0, this.scrollY);
    }
  }
}

export default BodyScroll;
